import React from 'react';
import BoughtTogether from './BoughtTogether';
import {Element, scroller} from 'react-scroll';
import TrackedButtonLink from "../../common/TrackedButtonLink";

class BoughtTogetherContainer extends React.Component {
	componentDidMount() {
		if (global.location.hash === '#accessories') {
			global.setTimeout(() => {
				scroller.scrollTo('accessories', {
					offset: -45
				});
			}, 50);
		}
	}
	render() {
		const boughtTogetherList = this.props.boughtTogether.map((boughtTogether, index) => {
			return <BoughtTogether boughtTogether={ boughtTogether } key={ index } />;
		});

		return (
			<section className="product-accessories" id="product-accessories">
				<Element name="accessories">
					<div className="row safes-callout">
						<div className="col sm-3 callout-descr">
							<h2 className="section-title">
								Frequently Bought Together
							</h2>
							<TrackedButtonLink
								className="btn btn-primary"
								to="/products?bestOfBest=true&protectionFrom=Fire&size=Large&size=Extra+Large&size=XX-Large"
							>
								View Best-Selling Fire Safes
							</TrackedButtonLink>
						</div>
						<div className="col sm-9 products">
							<ul>
								{ boughtTogetherList }
							</ul>
						</div>
					</div>
				</Element>
			</section>
		);
	}
}

export default BoughtTogetherContainer;


// WEBPACK FOOTER //
// ./src/pages/product/boughttogether/BoughtTogetherContainer.js